















































export default {
  data() {
    return {
      showFixedHeader: false,
      theadLeft: 0,
      theadWidth: 0,
    }
  },
  mounted() {
    this.onScroll()
    this.onResize()
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy(): void {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.theadLeft = this.$refs.thead.getBoundingClientRect().left
      this.theadWidth = this.$refs.thead.getBoundingClientRect().width
    },
    onScroll() {
      this.showFixedHeader = (window.pageYOffset || document.documentElement.scrollTop) > this.$refs.thead.offsetTop
    },
  },
}
